import { Subject } from 'rxjs';

/**
 * Contact Builder lead-form tracking Subjects (NHS20-8253). This feature has no analytics
 * knowledge of its own — components only .next() raw, semantic payloads here (see
 * services/leadFormTracking.js, the only code that emits onto these). Payloads carry `fromPage`
 * (the raw data-from-page value the triggering CTA rendered), not any provider- or page-shaped
 * concept like "position" — translating that into e.g. Native ISM's `ISM-Plan`/`ISM-Spec` is the
 * consuming page's job (see pages/communityDetail/components/eventTracking/), since this feature
 * is shared and has no business knowing what "ISM" means. Whichever page embeds this feature
 * subscribes and shapes/dispatches the actual Segment/GA4 events.
 */
export const leadOptionSelectedOccurred$ = new Subject();
export const leadFormSubmittedOccurred$ = new Subject();
export const leadFormClosedOccurred$ = new Subject();
export const leadFormAbandonedOccurred$ = new Subject();
export const leadFormSubmissionFailedOccurred$ = new Subject();

/**
 * "Get on the list" (Coming Soon "Get Notified") tracking Subjects (NHS20-8254). Same shape as
 * the Contact Builder Subjects above — this feature has no analytics knowledge of its own, only
 * components/getOnTheListForm.js (via services/getOnTheListTracking.js) emits onto these. Unlike
 * the Contact Builder Subjects, these payloads carry no `fromPage`/position-shaped data at all,
 * since the ticket's own event vocabulary (GA4's shared `native_map_events` name, Segment's
 * `Native Map Notify *` names) is already ISM-flavored and needs no page-side translation.
 */
export const notifySubmitClickedOccurred$ = new Subject();
export const notifySubmissionFailedOccurred$ = new Subject();
export const notifyModalClosedOccurred$ = new Subject();
export const notifyAbandonedOccurred$ = new Subject();
